"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmailValid = exports.isPasswordValid = exports.EMAIL_VALIDATION_REGEX = void 0;
const password_validator_1 = __importDefault(require("password-validator"));
// Email regex taken from: https://stackoverflow.com/a/46181
exports.EMAIL_VALIDATION_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const passwordSchema = new password_validator_1.default()
    .is()
    .min(8)
    .has()
    .uppercase()
    .has()
    .lowercase()
    .has()
    .digits()
    .has()
    .symbols();
function isPasswordValid(password) {
    return passwordSchema.validate(password);
}
exports.isPasswordValid = isPasswordValid;
function isEmailValid(email) {
    return exports.EMAIL_VALIDATION_REGEX.test(email);
}
exports.isEmailValid = isEmailValid;
//# sourceMappingURL=index.js.map